<template>
  <el-badge type="primary">
    <el-dialog title="Resultado" :append-to-body="false" center :visible.sync="result">
      <el-table
        :data="tableData"
        stripe
        ref="tableData"
        style="width: 100%"
        :default-sort="{ prop: 'content', order: 'ascending' }"
      >
        <el-table-column prop="tag" :label="$t('etiqueta')">
        </el-table-column>
        <el-table-column
          prop="message"
          :label="$t('mensagem')"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click.stop.prevent="result = false; dialog = false">OK</el-button>
      </span>
    </el-dialog>

    <el-button type="info" size="mini" plain @click="dialog = true">Voltar Objeto</el-button>
    <el-drawer title="Devolver Objetos Auditoria" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer"
      size="50%" :wrapperClosable="false" :append-to-body="true" :modal-append-to-body="false" :modal="true">
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="24">
              <el-form-item label="Objeto (separados por ',')">
                <el-input type="textarea" v-model="ruleForm.tag" :rows="15" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer" style="padding-top: 10px;">
          <el-button @click="$refs.drawer.closeDrawer();">Cancelar</el-button>
          <el-button type="primary" @click=" $refs.drawer.closeDrawer(); execute();">
            Reprocessar
          </el-button>
        </div>
      </div>
    </el-drawer>
  </el-badge>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
export default {
  data() {
    return {
      dialog: false,
      result: false,
      tableData: [],
      ruleForm: {
        tag: "",
      },
    }
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    execute() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const data = {
        tags: vm.ruleForm.tag.split(','),
      }
      AuditService.reprocess(data)
        .then((response) => {
          console.log(response);
          if (response.error) {
            return vm.$message({ type: "error", message: response.message });
          }
          vm.tableData = response.data;
          vm.result = true;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
  }
}
</script>